import { render, staticRenderFns } from "./comunicadoSlider.vue?vue&type=template&id=4804c288&"
import script from "./comunicadoSlider.vue?vue&type=script&lang=js&"
export * from "./comunicadoSlider.vue?vue&type=script&lang=js&"
import style0 from "./comunicadoSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports